export default __webpack_public_path__ + "static/media/hassle-free-s-curve.76ee3750.svg";